interface ReferralFormLayoutProps {
  children: React.ReactNode
  isFullWidth?: boolean
}

export default function ReferralFormLayout({
  children
}: ReferralFormLayoutProps) {
  return (
    <div className="absolute bottom-0 left-0 z-20 m-6 flex min-h-11 w-fit flex-col gap-4 rounded-xl bg-white p-6">
      {children}
    </div>
  )
}
